<template>
  <Modal
    class="scoped full-width"
    title="Bulk apply filter sets"
  >
    <QCard class="full-width">
      <QCardSection class="scroll">
        <FilterSetSelector
          v-model="filterSetIds"
          multiple
          :organisation-id="organisationId"
        />
      </QCardSection>
      <QCardActions>
        <div class="full-width flex justify-end">
          <div>
            <QBtn
              v-close-popup
              color="primary"
              flat
              label="Cancel"
              no-caps
              @click="cancel"
            />
            <QBtn
              color="black"
              label="Save"
              no-caps
              @click="save"
            />
          </div>
        </div>
      </QCardActions>
    </QCard>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

import FilterSetSelector from "src/components/filterSets/FilterSetSelector.vue";

export default {
  name: "InsightsQueriesFilterSetsModal",
  components: {
    FilterSetSelector,
    Modal,
  },
  props: {
    organisationId: {
      type: [Number, String],
      required: true,
    },
  },
  emits: ["close", "confirm"],
  data() {
    return {
      filterSetIds: [],
    };
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    save() {
      this.$emit("confirm", this.filterSetIds);
      this.$emit("close");
    },
  },
};
</script>
